import { useState, useContext } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import AuthContext from "../../context/authProvider";
import { PARTNER_NAV_ITEMS } from "./navItems";
import logo from "../../img/logo.svg";
import {
  mobileHeader,
  mobileIconBtn,
  mobileNavActive,
  mobileNavIdle,
  mobileRoot,
} from "../theme";

function isNavActive(item, pathname) {
  if (item.to === "/partner") {
    return pathname === item.to;
  }
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
}

function MobilePartnerShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();

  const currentItem = PARTNER_NAV_ITEMS.find((item) => isNavActive(item, location.pathname));
  const title = currentItem?.label ?? "Partner";

  const closeDrawer = () => setDrawerOpen(false);

  const handleLogout = () => {
    closeDrawer();
    logout();
  };

  return (
    <div className={mobileRoot}>
      <header className={mobileHeader}>
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          aria-label="Menu"
          className={mobileIconBtn}
        >
          ☰
        </button>
        <h1 className="flex-1 truncate text-lg font-semibold text-laranjinha">{title}</h1>
        <span className="min-w-[44px]" />
      </header>

      {drawerOpen && (
        <>
          <button
            type="button"
            aria-label="Fechar menu"
            className="fixed inset-0 z-40 bg-black/60"
            onClick={closeDrawer}
          />
          <nav
            aria-label="Navegação principal"
            className="fixed left-0 top-0 z-50 flex h-full w-72 max-w-[85vw] flex-col border-r border-primary bg-mgs-bg shadow-xl"
          >
            <div className="border-b border-primary/40 px-4 py-4">
              <img src={logo} alt="Manafix" className="h-10 w-auto" />
              <p className="mt-2 truncate text-sm font-medium text-laranjinha">{user.name}</p>
              <p className="truncate text-xs text-laranjinha/60">{user.email}</p>
            </div>
            <ul className="flex-1 overflow-y-auto py-2">
              {PARTNER_NAV_ITEMS.map((item) => {
                const active = isNavActive(item, location.pathname);
                return (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      onClick={closeDrawer}
                      className={`block min-h-[44px] px-4 py-3 text-sm ${
                        active ? mobileNavActive : mobileNavIdle
                      }`}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <div className="border-t border-primary/40 p-4">
              <button
                type="button"
                onClick={handleLogout}
                className="min-h-[44px] w-full rounded-lg px-4 py-2 text-left text-sm text-laranjinha hover:bg-monao"
              >
                Sair
              </button>
            </div>
          </nav>
        </>
      )}

      <main className="flex-1 overflow-y-auto bg-mgs-bg">
        <Outlet />
      </main>
    </div>
  );
}

export default MobilePartnerShell;
